import { writeOffInfo, updateWriteOffStatus } from "@/libs/api.js";
import { browser } from "@/libs/common.js";
import Qs from "qs";
export default {
  name: "signScan",
  data() {
    return {
      packageNo: "",
      isSign: false, //是否已签收
      writeOffSoList: [],
      packageInfo: null,
      orderData: null,
    };
  },

  mounted() {
    this.init();
  },
  methods: {
    init() {
      // this.errorAlert()
      this.packageNo = this.$route.query.packageNo;
      console.log(this.$route.query, browser());
      if (browser().ylxdsq || browser().ulemax) {
        //优鲜app才可以使用
        if (this.packageNo) {
          this.writeOffInfo();
        }
      } else {
        this.$dialog
          .alert({
            title: "提示",
            message: `抱歉，请使用优鲜APP客户端进行签收。`,
            confirmButtonText: "知道了",
            confirmButtonColor: "#FF2727",
          })
          .then(() => {
            // on confirm
            console.log("关闭页面");
            location.href = "ulemobile://ulePopView";
          });
      }
    },
    //查询
    writeOffInfo() {
      writeOffInfo({
        expressNo: this.packageNo,
      }).then((res) => {
        if (res.returnCode == "0000") {
          this.packageInfo = res.data || null;
          this.writeOffSoList = res.data.writeOffSoList || [];
          let orderData = [];
          this.writeOffSoList.forEach((item) => {
            if (item.customerOrderNo) {
              let customerOrderNo = item.customerOrderNo.split(",");

              customerOrderNo.forEach((item2) => {
                let orderDataItem = {
                  number2: item.buyMobile,
                  number: item.transUsrPhone,
                  adressId: item.pickUpPlaceId,
                  adress: item.pickUpPlaceName,
                  escOrderid: item2,
                  deleveryOrderId:item.deleveryOrderId
                };
                orderData.push(orderDataItem);
              });
            }
          });
          console.log("===orderData", orderData);
          this.orderData = orderData;
        }
      });
    },
    //签收
    signPackage() {
      let params = {
        expressNo: this.packageInfo.expressNo,
        writeOffStatus: "1",
        orderData: this.orderData
      };
      console.log("===params", params);
      this.$axios({
        method: "POST",
        url: updateWriteOffStatus,
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
        },
        data: params,
      })
        .then((res) => {
          console.log("===签收", res);
          if (res.data.returnCode == "0000") {
            this.successAlert();
            this.writeOffInfo();
            this.isSign = true;
          } else {
            this.$toast(res.data.returnMessage);
          }
        })
        .catch((err) => {
          console.log(err);
          // this.$toast(err.returnMessage||'签收失败，请稍后重试');
        });
    },
    scan() {
      // location.href = "ulemobile://ulePopView";
      // dsBridge.call("generalAction", {
      //   type: "1",
      //   android_action: "QrcodeResult",
      // });
      dsBridge.call("onNativeScan",{})
      console.log("扫码4");
    },
    signAlert() {
      this.$dialog
        .confirm({
          title: "提示",
          message: `当前商品是否确认签收\n确认签收后，将发送到货短信通知客户`,
          confirmButtonText: "确认团点签收",
          cancelButtonText: "取消",
          confirmButtonColor: "#FF2727",
        })
        .then(() => {
          // on confirm
          console.log("确认签收");
          this.signPackage();
        })
        .catch(() => {
          // on cancel
          console.log("取消签收");
        });
    },
    successAlert() {
      this.$dialog
        .confirm({
          title: "",
          message: `到货短信已发送`,
          confirmButtonText: "继续扫码签收",
          cancelButtonText: "返回",
          confirmButtonColor: "#FF2727",
        })
        .then(() => {
          // on confirm
          console.log("继续扫码签收");
          this.scan()
        })
        .catch(() => {
          // on cancel
          console.log("取消签收");
        });
    },
    errorAlert() {
      this.$dialog
        .alert({
          title: "提示",
          message: `抱歉，系统未查询到您在当前\n自提点的人员信息，无法进行签收。`,
          confirmButtonText: "知道了",
          confirmButtonColor: "#FF2727",
        })
        .then(() => {
          // on confirm
          location.href = "ulemobile://ulePopView";
        });
    },
  },
};
